module.exports = __webpack_public_path__ + "img/cytp.7b6bc6b1.svg";